/* Victorieboontje redesign — kleine interacties op paginasecties (geen libraries). */
(function () {
  if (window.__vbUi) return; window.__vbUi = true;

  // Indicatief koffieverbruik: personen × koppen × werkdagen × gram per kop, als bandbreedte (projectdoc 09 §11).
  function initCalc(root) {
    var gMin = parseFloat(root.dataset.gMin) || 12, gMax = parseFloat(root.dataset.gMax) || 16;
    var inputs = root.querySelectorAll('input[type=number]'), out = root.querySelector('[data-calc-out]');
    function num(el) { var v = parseFloat(el.value); return isFinite(v) && v > 0 ? v : 0; }
    function update() {
      var cups = 1; inputs.forEach(function (i) { cups *= num(i); });
      var lo = Math.round(cups * gMin / 1000), hi = Math.round(cups * gMax / 1000);
      out.textContent = cups > 0 ? (lo === hi ? 'ca. ' + lo : 'ca. ' + lo + '–' + hi) + ' kg p/m' : '–';
    }
    inputs.forEach(function (i) { i.addEventListener('input', update); });
    update();
  }

  // Abonnementskaarten: op mobiel één kaart tegelijk via tabs; de vaste balk volgt de gekozen kaart.
  function initPlans(root) {
    var tabs = [].slice.call(root.querySelectorAll('[data-plan-tab]'));
    if (!tabs.length) return;
    var sum = root.querySelector('[data-plan-sum]'), sub = root.querySelector('[data-plan-sub]'), cta = root.querySelector('[data-plan-cta]');
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab, panel = root.querySelector('[data-plan="' + t.dataset.planTab + '"]');
        t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1;
        if (panel) panel.hidden = !on;
        if (on && panel) {
          if (sum) sum.textContent = panel.dataset.summary;
          if (sub) sub.textContent = panel.dataset.sub;
          var link = panel.querySelector('a.btn');
          if (cta && link) cta.href = link.href;
        }
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.tabIndex = i === 0 ? 0 : -1;
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (d) { e.preventDefault(); select(tabs[(i + d + tabs.length) % tabs.length], true); }
      });
    });
  }

  // Machinecatalogus: filters (OF binnen een groep, EN tussen groepen), chips, sorteren en de filterlade op mobiel.
  function initCatalog(root) {
    var form = root.querySelector('[data-cat-form]'), list = root.querySelector('[data-cat-list]');
    if (!form || !list) return;
    var cards = [].slice.call(list.children), panel = root.querySelector('[data-cat-panel]');
    var chips = root.querySelector('[data-cat-chips]'), empty = root.querySelector('[data-cat-empty]');
    var counts = root.querySelectorAll('[data-cat-count]'), opener = root.querySelector('[data-cat-open]');
    function checked() {
      var g = {};
      form.querySelectorAll('input:checked').forEach(function (i) { (g[i.name] = g[i.name] || []).push(i); });
      return g;
    }
    function match(card, name, values) {
      var d = card.dataset;
      return values.some(function (v) {
        if (name === 'team') {
          var r = v.split('-'), lo = +r[0], hi = +r[1], mn = parseInt(d.teamMin, 10), mx = parseInt(d.teamMax, 10);
          if (isNaN(mx)) return false; if (isNaN(mn)) mn = 1;
          return mn <= hi && mx >= lo;
        }
        if (name === 'fin') return d[v] === 'true';
        return d[name] === v;
      });
    }
    function apply() {
      var g = checked(), n = 0;
      cards.forEach(function (c) {
        var ok = Object.keys(g).every(function (k) { return match(c, k, g[k].map(function (i) { return i.value; })); });
        c.hidden = !ok; if (ok) n++;
      });
      counts.forEach(function (el) { el.textContent = n; });
      if (empty) empty.hidden = n > 0;
      chips.innerHTML = '';
      Object.keys(g).forEach(function (k) { g[k].forEach(function (i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'vb-chip-x';
        b.textContent = i.nextElementSibling.textContent + ' ×';
        b.setAttribute('aria-label', 'Filter ' + i.nextElementSibling.textContent + ' verwijderen');
        b.addEventListener('click', function () { i.checked = false; apply(); });
        chips.appendChild(b);
      }); });
      if (chips.children.length) {
        var w = document.createElement('button'); w.type = 'button'; w.className = 'btn btn--link btn--underline'; w.textContent = 'wis filters';
        w.addEventListener('click', clear); chips.appendChild(w);
      }
      chips.hidden = !chips.children.length;
    }
    function clear() { form.querySelectorAll('input:checked').forEach(function (i) { i.checked = false; }); apply(); }
    function sort(mode) {
      var arr = cards.slice();
      arr.sort(function (a, b) {
        if (mode === 'price-asc') return a.dataset.price - b.dataset.price;
        if (mode === 'price-desc') return b.dataset.price - a.dataset.price;
        return (b.dataset.prio - a.dataset.prio) || (cards.indexOf(a) - cards.indexOf(b));
      });
      arr.forEach(function (c) { list.appendChild(c); });
    }
    function open() {
      panel.classList.add('is-open'); document.documentElement.classList.add('vb-noscroll');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-modal', 'true');
      var f = panel.querySelector('[data-cat-close]'); if (f) f.focus();
    }
    function close() {
      if (!panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open'); document.documentElement.classList.remove('vb-noscroll');
      panel.setAttribute('aria-modal', 'false');
      if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
    }
    form.addEventListener('change', apply);
    form.addEventListener('submit', function (e) { e.preventDefault(); });
    var sel = root.querySelector('[data-cat-sort]'); if (sel) sel.addEventListener('change', function () { sort(sel.value); });
    if (opener) opener.addEventListener('click', open);
    root.querySelectorAll('[data-cat-close]').forEach(function (b) { b.addEventListener('click', close); });
    var clr = root.querySelector('[data-cat-clear]'); if (clr) clr.addEventListener('click', clear);
    panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    // Voorselectie via de URL, bijv. ?type=piston (links vanuit de typetegels).
    var q = new URLSearchParams(location.search);
    form.querySelectorAll('input[type=checkbox]').forEach(function (i) { if (q.getAll(i.name).indexOf(i.value) > -1) i.checked = true; });
    sort('prio'); apply();
  }

  // Koffie-PDP: varianten via optiechips, eenmalig/abonnement (selling plans), aantal, prijs op de knop en verzendbalk.
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2), parts = v.split('.');
    var thou = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (fmt || '€{{amount_with_comma_separator}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals_with_comma_separator' || k === 'amount_no_decimals') return thou;
      if (k === 'amount') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
      return thou + ',' + parts[1];
    });
  }
  function initBuy(root) {
    var data; try { data = JSON.parse(root.querySelector('[data-buy-json]').textContent); } catch (e) { return; }
    var fmt = data.money, idIn = root.querySelector('[data-buy-variant]'), planIn = root.querySelector('[data-buy-plan]');
    var qty = root.querySelector('[data-buy-qty]'), add = root.querySelector('[data-buy-add]'), label = root.querySelector('[data-buy-label]');
    var freq = root.querySelector('[data-buy-freq]'), planSel = root.querySelector('[data-buy-plan-select]');
    var shipText = root.querySelector('[data-buy-ship-text]'), shipBar = root.querySelector('[data-buy-ship-bar]');
    var threshold = parseInt(root.dataset.threshold, 10) || 0, cartTotal = parseInt(root.dataset.cartTotal, 10) || 0;
    var mainImg = root.querySelector('[data-gallery-main]');
    function current() {
      var sel = [].map.call(root.querySelectorAll('[data-buy-opt]:checked'), function (i) { return i.value; });
      return data.variants.filter(function (v) { return v.options.every(function (o, i) { return sel[i] === undefined || o === sel[i]; }); })[0];
    }
    function isPlan() { var t = root.querySelector('[data-buy-type]:checked'); return t && t.value === 'plan'; }
    function update() {
      var v = current(); if (!v) return;
      idIn.value = v.id;
      var planId = planSel ? planSel.value : '', planPrice = v.plans[planId] || v.price;
      var unit = isPlan() ? planPrice : v.price, n = Math.max(1, parseInt(qty.value, 10) || 1);
      if (planIn) { planIn.disabled = !isPlan(); planIn.value = isPlan() ? planId : ''; }
      if (freq) freq.hidden = !isPlan();
      var once = root.querySelector('[data-buy-price-once]'), pl = root.querySelector('[data-buy-price-plan]');
      if (once) once.textContent = money(v.price, fmt); if (pl) pl.textContent = money(planPrice, fmt);
      add.disabled = !v.available; add.setAttribute('aria-disabled', String(!v.available));
      label.textContent = v.available ? 'In winkelmand · ' + money(unit * n, fmt) : 'Uitverkocht';
      if (shipText && threshold) {
        var rest = threshold - cartTotal - unit * n;
        shipText.textContent = rest > 0 ? 'Nog ' + money(rest, fmt) + ' tot gratis verzending' : 'Je bestelling wordt gratis verzonden';
        shipBar.style.width = Math.min(100, Math.round((threshold - Math.max(rest, 0)) / threshold * 100)) + '%';
      }
      if (v.media && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = v.media; }
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    }
    root.addEventListener('change', function (e) { if (e.target.matches('[data-buy-opt],[data-buy-type],[data-buy-plan-select],[data-buy-qty]')) update(); });
    qty.addEventListener('input', update);
    root.querySelectorAll('[data-qty]').forEach(function (b) { b.addEventListener('click', function () {
      qty.value = Math.min(99, Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.qty, 10))); update();
    }); });
    update();
  }

  // Koffieraster: één filterchip tegelijk (producttag) en sorteren.
  function initCgrid(root) {
    var list = root.querySelector('[data-cg-list]'); if (!list) return;
    var cards = [].slice.call(list.children), chips = root.querySelectorAll('[data-cg-tag]');
    // Chips zonder treffers verbergen (tag nog niet in gebruik).
    chips.forEach(function (c) { var t = c.dataset.cgTag; if (t && !cards.some(function (k) { return k.dataset.tags.indexOf('|' + t + '|') > -1; })) c.hidden = true; });
    chips.forEach(function (c) { c.addEventListener('click', function () {
      var t = c.dataset.cgTag;
      chips.forEach(function (o) { o.setAttribute('aria-pressed', String(o === c)); });
      cards.forEach(function (card) { card.hidden = !!t && card.dataset.tags.indexOf('|' + t + '|') === -1; });
    }); });
    var sel = root.querySelector('[data-cg-sort]');
    if (sel) sel.addEventListener('change', function () {
      cards.slice().sort(function (a, b) {
        if (sel.value === 'price-asc') return a.dataset.price - b.dataset.price;
        if (sel.value === 'price-desc') return b.dataset.price - a.dataset.price;
        return a.dataset.pos - b.dataset.pos;
      }).forEach(function (c) { list.appendChild(c); });
    });
  }

  // Productgalerij: miniaturen wisselen de hoofdfoto (koffie- en machine-PDP).
  function initGallery(root) {
    var main = root.querySelector('[data-gallery-main]');
    root.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.addEventListener('click', function () {
      if (!main) return;
      main.src = t.dataset.src; main.srcset = t.dataset.srcset;
      root.querySelectorAll('[data-gallery-thumb]').forEach(function (o) { o.classList.toggle('is-active', o === t); o.removeAttribute('aria-current'); });
      t.setAttribute('aria-current', 'true');
    }); });
  }

  // Keuzehulp in focusmodus (Figma 31:512): één vraag tegelijk, voortgang, tot-nu-toe-chips, vorige/volgende.
  // Progressive enhancement: zonder JS blijven alle vragen zichtbaar; de adviesberekening zit in vb-redesign.js.
  function initStepper(form) {
    var steps = [].slice.call(form.querySelectorAll(':scope > fieldset')); if (steps.length < 2) return;
    var submit = form.querySelector('[type=submit]'), i = 0;
    var bar = document.createElement('div'); bar.className = 'vb-steps-bar'; bar.setAttribute('aria-hidden', 'true');
    steps.forEach(function () { bar.appendChild(document.createElement('span')); });
    var so = document.createElement('p'); so.className = 'vb-sofar'; so.hidden = true;
    var nav = document.createElement('div'); nav.className = 'vb-kh__nav';
    var prev = document.createElement('button'); prev.type = 'button'; prev.className = 'vb-kh__prev'; prev.textContent = 'Vorige';
    var next = document.createElement('button'); next.type = 'button'; next.className = 'vb-btn vb-btn--primary'; next.textContent = 'Volgende';
    var live = document.createElement('p'); live.className = 'vb-visually-hidden'; live.setAttribute('aria-live', 'polite');
    nav.appendChild(prev); nav.appendChild(next); nav.appendChild(submit);
    form.insertBefore(so, steps[0]); form.insertBefore(bar, so); form.appendChild(nav); form.appendChild(live);
    form.classList.add('is-stepped');
    function answered(f) { return !!f.querySelector('input:checked'); }
    function show(n) {
      i = Math.max(0, Math.min(steps.length - 1, n));
      steps.forEach(function (f, k) { f.hidden = k !== i; });
      [].forEach.call(bar.children, function (b, k) { b.classList.toggle('on', k <= i); });
      prev.hidden = i === 0; next.hidden = i === steps.length - 1; submit.hidden = i !== steps.length - 1;
      next.disabled = !answered(steps[i]);
      var chips = steps.slice(0, i).map(function (f) { return [].map.call(f.querySelectorAll('input:checked'), function (c) { return c.closest('label').textContent.trim(); }).join(' + '); }).filter(Boolean);
      so.hidden = !chips.length;
      so.innerHTML = '<span>Tot nu toe:</span>' + chips.map(function (t) { return '<span class="vb-sofar__chip">' + t.replace(/[<>&]/g, '') + '</span>'; }).join('');
      live.textContent = 'Vraag ' + (i + 1) + ' van ' + steps.length;
    }
    prev.addEventListener('click', function () { show(i - 1); steps[i].querySelector('input').focus(); });
    next.addEventListener('click', function () { show(i + 1); var f = steps[i].querySelector('input:checked') || steps[i].querySelector('input'); if (f) f.focus(); });
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type=checkbox]')) { next.disabled = !answered(steps[i]); return; }
      if (!e.target.matches('input[type=radio]')) return;
      next.disabled = !answered(steps[i]);
      if (i < steps.length - 1) setTimeout(function () { show(i + 1); var f = steps[i].querySelector('input'); if (f) f.focus(); }, 180);
    });
    form.addEventListener('submit', function () {
      form.classList.add('is-done');
      setTimeout(function () {
        var out = form.parentNode.querySelector('[data-kh-result]'); if (!out || out.querySelector('.vb-kh__edit')) return;
        var b = document.createElement('button'); b.type = 'button'; b.className = 'vb-kh__edit'; b.textContent = 'Antwoorden aanpassen';
        b.addEventListener('click', function () { form.classList.remove('is-done'); out.hidden = true; show(0); form.scrollIntoView({ block: 'start' }); });
        out.insertBefore(b, out.firstChild);
      }, 0);
    });
    show(0);
  }

  function init() {
    document.querySelectorAll('[data-kh-form]').forEach(initStepper);
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-vb-cgrid]').forEach(initCgrid);
    document.querySelectorAll('[data-vb-buy]').forEach(initBuy);
    document.querySelectorAll('[data-vb-catalog]').forEach(initCatalog);
    document.querySelectorAll('[data-vb-calc]').forEach(initCalc);
    document.querySelectorAll('[data-vb-plans]').forEach(initPlans);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
